export const ENVIRONMENT = {
    BASE_URL_API: process.env.NEXT_PUBLIC_BASE_URL_API ?? 'https://www.apigwrconstruct.com.br', 
    LIMITE_DE_LINHA: process.env.LIMITE_DE_LINHA ?? 10,
    INPUT_DE_BUSCA: process.env.INPUT_DE_BUSCA ?? 'Pesquisar',
    LISTAGEM_VAZIA: process.env.LISTAGEM_VAZIA ?? 'Nenhum registro encontrado',
    PORT: process.env.PORT ?? 3001,
    REACT_APP_VERSION: process.env.REACT_APP_VERSION ?? '1.10.0',
    REACT_APP_BUILD_DATE: process.env.REACT_APP_BUILD_DATE ?? '2026.10',
}; 